import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/pro-light-svg-icons';
import {
  Alert, Button, List, Spin, Icon
} from 'antd';
import { Link } from 'react-router-dom';
import BackgroundColorContainer from '../components/other/BackgroundColorContainer';
import { Box, Text } from '../../shared/components';
import ShowIf from '../../shared/components/dataDisplay/ShowIf';
import NotificacionListItem from '../components/dataDisplay/NotificacionListItem';
import {
  limpiarNotificaciones,
  obtenerNotificacionesDesdeSevidor,
  obtenerSuscripcionesDesdeServidor,
} from '../../../state/actions/creators/giotalk.actioncreator';
import GiotalkHeader from '../components/other/GiotalkHeader';
import { obtenerEstadoRequestDesdeSaga } from '../../../helpers/sagaStatus.helper';
import theme from '../../../theme';

const legacyPrimaryColor = theme.colors.legacyPrimary;

class NotificacionesGIOTalk extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      totalNoLeido: null,
    };
  }

  componentDidMount() {
    const { notificaciones: { subscripciones } } = this.props;
    const { estadoPeticionObtenerNotificaciones: { running } } = this.props;
    const { limpiarNotificaciones, obtenerSuscripcionesDesdeServidor, obtenerNotificacionesDesdeSevidor } = this.props;
    const { notificaciones: { totalNoLeido } } = this.props;
    this.setState({ totalNoLeido });
    limpiarNotificaciones();
    obtenerSuscripcionesDesdeServidor();
  }

  handleInfiniteOnLoad() {
    const {
      notificaciones,
      obtenerNotificacionesDesdeSevidor,
      estadoPeticionObtenerNotificaciones: { running },
    } = this.props;
    const { mensajes, total } = notificaciones;
    if (running !== true && (mensajes.length < total || total === null)) obtenerNotificacionesDesdeSevidor({ marcarComoLeido: true });
  }

  render() {
    const { notificaciones, history, estadoPeticionObtenerNotificaciones: { running, success } } = this.props;
    const {
      nombre, mensajes, subscripciones,
    } = notificaciones;
    const { totalNoLeido } = this.state;
    const hayProblemaConexion = (running === false && success === false);
    const cargandoNotificaciones = running === true;

    const link = '/talk/notificaciones/opciones';
    const textoNumeroMensajesLeidos = `${totalNoLeido} notificaciones nuevas`;
    const subscripcionesCargadas = subscripciones !== undefined && subscripciones.length > 0;

    return (
      <BackgroundColorContainer color="#063340">
        <Box>
          <Box p="16">
            <GiotalkHeader
              onBackButtonPressed={() => history.goBack()}
              rightContent={(
                <Link to={link}>
                  <Button disabled={!subscripcionesCargadas} ghost style={{ float: 'right' }}>
                    <FontAwesomeIcon spin={!subscripcionesCargadas} icon={faCog} color="lightgrey" />
                  </Button>
                </Link>
              )}
              subtitle={(
                <ShowIf condition={totalNoLeido > 0}>
                  <Box mt="4">
                    <Text fontSize="12" color="white">{textoNumeroMensajesLeidos}</Text>
                  </Box>
                </ShowIf>
              )}
              title={nombre}
            />
          </Box>
          <ShowIf condition={hayProblemaConexion}>
            <Alert
              type="warning"
              message={
                <Text>Ha ocurrido un problema de conexión.</Text>
              }
            />
          </ShowIf>
          <InfiniteScroll
            initialLoad
            pageStart={0}
            loadMore={() => this.handleInfiniteOnLoad()}
            hasMore
            useWindow
          >
            <List
              dataSource={mensajes}
              renderItem={mensaje => <Box p="16" style={{ backgroundColor: legacyPrimaryColor }}><NotificacionListItem mensaje={mensaje} /></Box> }
            >
              {<ShowIf condition={cargandoNotificaciones}>
                <Box mt="16">
                  <Spin
                    style={{ margin: 'auto auto', display: 'block', color: 'white' }}
                    indicator={
                      <Icon type="loading" style={{ fontSize: 32 }} spin />
                    }
                  />
                </Box>
                  </ShowIf>}
            </List>
          </InfiniteScroll>
        </Box>
      </BackgroundColorContainer>

    );
  }
}

const mapStateToProps = (state) => {
  const { sagas, giotalk: { notificaciones } } = state;
  return {
    notificaciones,
    estadoPeticionObtenerNotificaciones: obtenerEstadoRequestDesdeSaga(sagas, 'GIOTALK_OBTENER_NOTIFICACIONES'),
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    obtenerNotificacionesDesdeSevidor,
    limpiarNotificaciones,
    obtenerSuscripcionesDesdeServidor,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificacionesGIOTalk);
